import React, { useState, useEffect, useRef } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import { useApiFetch } from "../utils/apiFetch";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "../styles/VisualizarIndicadores.css";
import "../styles/Formularios.css";
import jsPDF from "jspdf";
import logo from "../assets/logo_sict.png";


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

function VisualizarIndicadores() {

    const { identidad, logout } = useGlobal();
    const [dataApi, setDataApi] = useState(null);
    const [mensaje, setMensaje] = useState("");
    const [loading, setLoading] = useState(true);
    const apiFetch = useApiFetch();
    const chartRef = useRef(null);

    useEffect(() => {
        if (!identidad) {
            setMensaje("Debes iniciar sesión para ver los indicadores.");
            setLoading(false);
            return;
        }

        const cargarIndicadores = async () => {
            try {
                const data = await apiFetch("visualizar_indicadores.php", { method: "GET" }, logout);
                console.log("Respuesta API:", data);
                setDataApi(data);
            } catch {
                setMensaje("Error de conexión con la API.");
            } finally {
                setLoading(false);
            }
        };

        cargarIndicadores();
    }, [identidad]);

    if (loading) return <p>Cargando indicadores...</p>;
    if (mensaje) return <p className="error">{mensaje}</p>;
    if (!dataApi) return null;

    // Se usa el array directo
    const tecnicos = Array.isArray(dataApi.tecnicos) ? dataApi.tecnicos : [];

    // Se preparan los datos para la gráfica
    const labels = tecnicos.map(t =>
        `${t.nombreTecnico}\n${t.porcentaje_positivas}%`
    );
    const negativas = tecnicos.map(t => Number(t.negativas) || 0);
    const positivas = tecnicos.map(t => Number(t.positivas) || 0);
    const porCerrar = tecnicos.map(t => Number(t.porCerrar) || 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: "Negativas",
                data: negativas,
                backgroundColor: "rgba(214, 82, 82, 0.7)"
            },
            {
                label: "Positivas",
                data: positivas,
                backgroundColor: "rgba(75, 192, 192, 0.77)"
            },
            {
                label: "Por Cerrar",
                data: porCerrar,
                backgroundColor: "rgba(255, 207, 86, 0.59)"
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: "Indicadores por Técnico"
            },
            tooltip: {
                mode: "index",
                intersect: false
            },
            legend: {
                position: "top"
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    callback: function (value, index) {
                        const tecnico = tecnicos[index];
                        // Para acomodar las lineas una debajo de la otra dentro de la gráfica
                        return [
                            tecnico.nombreTecnico || "Sin nombre",
                            tecnico.porcentaje_positivas + "%"
                        ];
                    }
                }
            },
            y: {
                stacked: true,
                beginAtZero: true
            }
        }
    };

    // Exportar en PDF
    const exportarGraficaPDF = () => {
        const doc = new jsPDF("landscape"); // Se orienta de modo horizontal

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Indicadores por Técnico", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 280, 40);

        // Gráfica
        if (chartRef.current) {
            const chartInstance = chartRef.current;
            const imgData = chartInstance.toBase64Image();
            // Ajusta dimensiones y posición según tu preferencia
            doc.addImage(imgData, "PNG", 15, 50, 260, 120);
        }

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2025-2026 SIGBI-712. Todos los derechos reservados.", 10, 190);

        doc.save("indicadores.pdf");
    };

    // Exportar en formato CSV
    const exportarCSV = () => {
        if (!tecnicos || tecnicos.length === 0) return;

        // Encabezados
        const filas = [
            ["Técnico", "Negativas", "Positivas", "Por Cerrar", "% Productividad"],
            ...tecnicos.map(t => [
                t.nombreTecnico,
                t.negativas,
                t.positivas,
                t.porCerrar,
                t.porcentaje_positivas + "%"
            ])
        ];

        // Convertir a CSV
        const csvContent = filas.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Crear link de descarga
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "indicadores_tecnicos.csv");
        link.click();
    };

    return (
        <div className="control-contenedor">

            <div className="titulo-seccion">
                <h2>Visualización de Indicadores</h2>
                <h3>Total Global: {dataApi.total_global}</h3>
            </div>

            <Bar ref={chartRef} data={chartData} options={options} />

            <div className="form-buttons">
                <button onClick={exportarGraficaPDF}>Exportar gráfica<br></br>en PDF</button>
                <button onClick={exportarCSV}>Exportar datos<br></br>en CSV</button>
            </div>

        </div>
    );
}

export default VisualizarIndicadores;
